export default __webpack_public_path__ + "static/media/Medeata200blue.a6d0fa45.svg";